"use client"

import { CasinoDashboard } from "@/components/casino/casino-dashboard"
import { useSearchParams } from "next/navigation"

export default function HomePage() {
  const searchParams = useSearchParams()
  const verifiedEmail = searchParams?.get('verified_email')
  const isDeposit = searchParams?.get('deposit') === 'true'
  
  // Extraer datos de la orden si existen
  let orderData = null
  try {
    const orderDataString = searchParams?.get('order_data')
    if (orderDataString) {
      orderData = JSON.parse(orderDataString)
    }
  } catch (error) {
    console.error('Error parsing order data:', error)
  }

  return (
    <div className="min-h-screen bg-background">
      <CasinoDashboard 
        verifiedEmail={verifiedEmail || undefined}
        shouldStartDeposit={isDeposit}
        orderData={orderData}
      />
    </div>
  )
}
